export class DocumentAddNotification {
	viewId: number;
	folderId: string;
	documentId: string;

	public static fromJson(other: any): DocumentAddNotification {
		const instance = new DocumentAddNotification();
		instance.folderId = other.FolderId;
		instance.documentId = other.DocumentId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
